import React from 'react';
import './AccountStatusField.css';

const AccountStatusField = ({ formik, accountType }) => {
  const vendor = accountType === 'vendor';
  const field = vendor ? 'is_enabled' : 'is_active';
  const label = vendor ? 'Vendor status' : 'User status';
  const enabled = Boolean(formik.values[field]);
  const id = 'account-' + field;
  const error = formik.errors[field];

  return (
    <fieldset className="border rounded p-3 mb-3" disabled={formik.isSubmitting}>
      <legend className="h6 mb-2">{vendor ? 'Vendor Status' : 'User Status'}</legend>
      <div className="account-status-switch">
        <input
          id={id}
          name={field}
          type="checkbox"
          role="switch"
          className="account-status-switch__input"
          checked={enabled}
          aria-label={label}
          aria-describedby={id + '-help' + (error ? ' ' + id + '-error' : '')}
          aria-invalid={Boolean(error)}
          onChange={event => formik.setFieldValue(field, event.target.checked)}
          onBlur={formik.handleBlur}
        />
        <label htmlFor={id} className="account-status-switch__label">
          <span className="account-status-switch__track" aria-hidden="true">
            <span className="account-status-switch__thumb" />
          </span>
          {vendor ? (enabled ? 'Enabled' : 'Disabled') : (enabled ? 'Active' : 'Deactive')}
        </label>
      </div>
      <p id={id + '-help'} className="small text-muted mt-2 mb-0">
        {vendor
          ? 'Disabling this Vendor prevents the Vendor and all their users from logging in. Each user keeps their individual status.'
          : 'Deactivating this user prevents only this user from logging in. Their Vendor must also be enabled to allow access.'}
      </p>
      {error && <div id={id + '-error'} className="invalid-feedback d-block" role="alert">{error}</div>}
    </fieldset>
  );
};

export default AccountStatusField;
